// 운영은 기본 주소를 사용하고 로컬 실행 시 .env.local 값으로 변경한다.
export const DOMAIN = process.env.VUE_APP_AGENCY_API_BASE_URL || "https://api.uni-core.co.kr";
